/**
 * Компонент для автоматического сброса прокрутки при навигации
 */
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export function ScrollToTop() {
  const { pathname } = useLocation()
  
  useEffect(() => {
    // Мгновенно сбрасываем прокрутку в 0 при изменении маршрута
    window.scrollTo(0, 0)
  }, [pathname])
  
  return null
}
